function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable func-names */
import React from 'react';
import { default as RadioWrapper } from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import _merge from 'lodash/merge';
import { Typography } from "../Typography/index.js";
import { Box } from "../Box/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { color, typography } from "../../utils/index.js";
var BpIcon = function BpIcon() {
  return /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      borderRadius: '50%',
      width: 18,
      height: 18,
      border: '1px solid',
      borderColor: color(COLOR_VARIANTS.GREYCHATEAU),
      '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2
      },
      'input:hover ~ &': {
        borderColor: color(COLOR_VARIANTS.AQUA100)
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        borderColor: color(COLOR_VARIANTS.ALICE)
      }
    }
  });
};
var BpCheckedIcon = function BpCheckedIcon() {
  return /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: {
      borderRadius: '50%',
      border: '1px solid',
      borderColor: color(COLOR_VARIANTS.AQUA100),
      backgroundColor: color(COLOR_VARIANTS.WHITE),
      position: 'relative',
      width: 18,
      height: 18,
      '&:before': {
        position: 'absolute',
        display: 'block',
        width: 8,
        height: 8,
        borderRadius: 50,
        content: '""',
        backgroundColor: color(COLOR_VARIANTS.AQUA100),
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto'
      },
      'input:hover ~ &': {
        borderColor: color(COLOR_VARIANTS.AQUA100)
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        opacity: '0.4',
        borderColor: 'red'
      }
    }
  });
};
var BpRadioButton = function BpRadioButton(props) {
  return /*#__PURE__*/React.createElement(RadioWrapper, _extends({
    disableRipple: true,
    color: "default",
    checkedIcon: /*#__PURE__*/React.createElement(BpCheckedIcon, null),
    icon: /*#__PURE__*/React.createElement(BpIcon, null),
    inputProps: {
      'aria-label': 'Checkbox demo'
    }
  }, props));
};
export var Radiobutton = function Radiobutton(_ref) {
  var isDisabled = _ref.isDisabled,
    label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange,
    name = _ref.name,
    options = _ref.options,
    testId = _ref.testId,
    id = _ref.id,
    className = _ref.className,
    _ref$isSingle = _ref.isSingle,
    isSingle = _ref$isSingle === void 0 ? false : _ref$isSingle;
  return /*#__PURE__*/React.createElement(FormControl, {
    id: id,
    "data-testid": testId,
    disabled: isDisabled,
    className: "__ds__comp ".concat(className)
  }, label && /*#__PURE__*/React.createElement(FormLabel, {
    id: "".concat(id, "-group-label"),
    focused: false,
    sx: _merge({
      color: color(COLOR_VARIANTS.MINESHAFT),
      marginTop: '1px',
      marginBottom: '16px'
    }, typography(TYPOGRAPHY_VARIANT.HEADING3SEMBLD))
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.HEADING3SEMBLD,
    color: COLOR_VARIANTS.MINESHAFT,
    component: "p"
  }, label)), /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-labelledby": "".concat(id, "-group-label"),
    id: "".concat(id, "-radio-buttons-group"),
    name: "".concat(id, "-radio-buttons-group"),
    value: value,
    onChange: onChange
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      value: option.value,
      control: /*#__PURE__*/React.createElement(BpRadioButton, {
        onClick: option.onClick,
        checked: option.isChecked
      }),
      label: /*#__PURE__*/React.createElement(Box, {
        sx: {
          display: 'flex',
          alignItems: option.subTitle ? '' : 'center'
        }
      }, option.icon && /*#__PURE__*/React.createElement(Box, {
        sx: {
          marginRight: '8px',
          display: 'flex'
        },
        id: "checkbox-with-icon"
      }, option.icon), /*#__PURE__*/React.createElement(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: option.label
        }
      }), option.subTitle && /*#__PURE__*/React.createElement(Typography, {
        component: "p",
        variant: TYPOGRAPHY_VARIANT.CAPTIONREG,
        color: COLOR_VARIANTS.GREYCHATEAU
      }, option.subTitle)), /*#__PURE__*/React.createElement(Box, {
        sx: {
          display: 'flex'
        }
      }, option.trailingText && /*#__PURE__*/React.createElement(Typography, {
        component: "p",
        variant: TYPOGRAPHY_VARIANT.CAPTIONREG,
        color: COLOR_VARIANTS.GREYCHATEAU
      }, option.trailingText), (option === null || option === void 0 ? void 0 : option.endIcon) && /*#__PURE__*/React.createElement(Typography, {
        sx: {
          marginInlineStart: '8px',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: color(COLOR_VARIANTS.FOREST100),
          borderRadius: '4px',
          padding: '8px'
        },
        component: "p",
        variant: TYPOGRAPHY_VARIANT.CAPTIONREG,
        color: COLOR_VARIANTS.WHITE
      }, option.endIcon)))),
      disabled: option.isDisabled,
      "data-testid": option.testId
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: "key-".concat(option.value),
      name: name,
      sx: {
        color: color(COLOR_VARIANTS.MINESHAFT),
        alignItems: 'flex-start',
        marginBottom: isSingle ? '0' : '16px',
        '& .MuiFormControlLabel-label': _merge({
          marginTop: '3px',
          width: '100%'
        }, typography(TYPOGRAPHY_VARIANT.BODY2)),
        '& .MuiRadio-root': {
          padding: 0,
          margin: '4px 9px'
        },
        '& .MuiRadio-root:hover': {
          backgroundColor: 'transparent'
        },
        '&:hover': {
          color: color(COLOR_VARIANTS.AQUA100)
        },
        '& .MuiFormControlLabel-label.Mui-disabled': {
          color: color(COLOR_VARIANTS.GREYCHATEAU)
        }
      }
    });
  })));
};